import React, { useEffect } from 'react';
import marketing from './content';
import Digi from './Digi';
import { track } from './track';
import { startJourney } from './journey';

export default function App() {
  // Jornada do visitante: captura local (localStorage), enviada só com o lead.
  useEffect(() => startJourney('index'), []);

  // Rastreamento de cliques em CTAs: qualquer elemento com [data-track] vira um
  // evento cta_click no dataLayer (GTM). Delegado no document p/ pegar o HTML
  // injetado via dangerouslySetInnerHTML.
  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest('[data-track]');
      if (!el) return;
      track('cta_click', { label: el.dataset.track, page: 'plataforma' });
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  // Filtro do diretorio de parceiros (#pfilter) — portado do script inline original.
  useEffect(() => {
    const fw = document.getElementById('pfilter');
    if (!fw) return undefined;
    const onClick = (e) => {
      const b = e.target.closest('button');
      if (!b) return;
      fw.querySelectorAll('button').forEach((x) => x.classList.toggle('on', x === b));
      const f = b.dataset.filter;
      document.querySelectorAll('#pdir .pdir-card').forEach((c) => {
        c.style.display = f === 'all' || c.dataset.tags.indexOf(f) > -1 ? '' : 'none';
      });
    };
    fw.addEventListener('click', onClick);
    return () => fw.removeEventListener('click', onClick);
  }, []);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: marketing }} />
      <Digi />
    </>
  );
}
